module.exports = __webpack_public_path__ + "media/images/gspmain-c5d71f16b7a133fe2cbff09c7847825b.jpg";